<template>
  <div class="list-wrapper">
    <div class="exchange_content">
      <div class="exchange_ipt">
        <input v-model='couponcode' type="text" placeholder='请输入优惠码' @input='checkCode'>
        <van-icon v-if="!disabledFlag" @click="clearInput" name="clear"/>
        <button :disabled='disabledFlag' class="exchange_btn" :class="{disabled:disabledFlag}" @click='changecoupon'>
          兑换
        </button>
      </div>
      <p class="all_tab" v-if="vip_coupon_num !== 0 && vip_coupon_num !== -1">
        <span @click='checkAllTab(1)' :class="{all_index: allIndex == 1}">全部({{all_coupon_num}})</span>
        <span @click='checkAllTab(2)' :class="{all_index: allIndex == 2}">会员专属({{vip_coupon_num}})</span>
        <span @click='checkAllTab(3)' :class="{all_index: allIndex == 3}">其他({{other_coupon_num}})</span>
      </p>
      <p class="exchange_tab">
        <span @click='checkUseableTab(1)' :class="{content_index: current == 1}">可使用优惠券({{usenum}})</span>
        <span @click='checkUseableTab(2)' :class="{content_index: current == 2}">不可使用优惠券({{unusenum}})</span>
      </p>
    </div>
    <div v-if="current == 1">
      <div class="coupon_content" v-if="usecouponlist != ''">
        <div class="coupon_detail" v-for='(i, index) in usecouponlist' :key="index">
          <p class="coupon_left"><span class="coupon_price">￥<span>{{i.coupon.couponMoney/100}}</span></span>
            <span class="coupon_condition" v-if="i.coupon.withAmount">满{{i.coupon.withAmount/100}}元使用</span>
            <span class="coupon_condition" v-else>无使用门槛</span>
          </p>
          <p class="coupon_center"><span class="coupon_name">{{i.coupon.name}}</span>
            <span
              class="validity">有效期：{{validFormat(i.coupon.validStartTime)}} - {{validFormat(i.coupon.validEndTime)}}</span>
          </p>
          <!-- <p class="coupon_right" @click="useCoupon(i)">去使用</p> -->
        </div>
      </div>
      <div class="coupon_wrapper" v-else>
        <div>
          <img src="../../../static/images/coupon.png">
          <p>暂无优惠码</p>
        </div>
      </div>
    </div>
    <div v-else-if="current == 2">
      <div class="coupon_content" v-if="couponlist != ''">
        <div class="coupon_box" v-for='(i, index) in couponlist' :key="index">
          <div class="coupon_detail coupon_content_pass">
            <p class="coupon_left"><span class="coupon_price">￥<span>{{i.coupon.couponMoney/100}}</span></span>
              <span class="coupon_condition" v-if="i.coupon.withAmount">满{{i.coupon.withAmount/100}}元使用</span>
              <span class="coupon_condition" v-else>无使用门槛</span>
            </p>
            <p class="coupon_center"><span class="coupon_name">{{i.coupon.name}}</span>
              <span class="validity">有效期:{{validFormat(i.coupon.validStartTime)}} - {{validFormat(i.coupon.validEndTime)}}</span>
            </p>
          </div>
          <div class="pass_tag">
            <span v-if="i.isUsed">优惠码已使用</span>
            <span v-else-if="new Date(i.coupon.validStartTime) > new Date().getTime()">未到可用时间</span>
            <span v-else-if="i.reason">{{i.reason}}</span>
            <span v-else>优惠码已过期</span>
          </div>
        </div>
      </div>
      <div class="coupon_wrapper" v-else>
        <div>
          <img src="../../../static/images/coupon.png">
          <p>暂无优惠码</p>
        </div>
      </div>
    </div>
    <div class="goods_wrapper" v-if="show">
      <div class="goods_box">
        <img class="closeList" @click="closeList" src="../../../static/images/guanbi.png">
        <p class="goods_title">商品列表</p>
        <p class="goods_rule" v-if="withAmount">以下商品可使用满{{withAmount}}元减{{couponMoney / 100}}元的优惠券</p>
        <p class="goods_rule" v-else>以下商品可使用无门槛优惠券</p>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :immediate-check='false'>
          <van-cell v-for="(item, index) in goodsList" :key="index">
            <div class="goods_list" @click="goShop(item.url)">
              <div class="goods_content">
                <img :src="'//s.eoffcn.com/' + item.img">
                <div class="goods_detail">
                  <p class="goods_name">{{item.name}}</p>
                  <p class="goods_price">¥ <span v-if="item.minPrice">{{item.minPrice / 100}} - </span>{{item.maxPrice /
                    100}}</p>
                </div>
              </div>
            </div>
          </van-cell>
        </van-list>
        <div class="unuse_list" v-if="use.length">
          <p class="goods_rules">以下商品已参加了其他优惠活动，暂时无法使用优惠券</p>
          <div class="goods_list" v-for="(item, index) in use" :key="index">
            <div class="goods_content">
              <img :src="'//s.eoffcn.com/' + item.img">
              <div class="goods_detail">
                <p class="goods_name">{{item.name}}</p>
                <p class="goods_price">¥ <span v-if="item.minPrice">{{item.minPrice / 100}} - </span>{{item.maxPrice /
                  100}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {Toast} from 'vant'

  export default {
    data () {
      return {
        ticket: this.$route.query.ticket,
        phone: this.$route.query.phone,
        sign: this.$route.query.sign,
        platform: this.$route.query.platform,
        version: this.$route.query.version,
        appid: this.$route.query.appId,
        isAndroid: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,
        isiOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
        usecouponlist: [],
        couponlist: [],
        usenum: 0,
        unusenum: 0,
        all_coupon_num: -1,
        vip_coupon_num: -1,
        other_coupon_num: -1,
        couponcode: '',
        current: 1,
        allIndex: 1,
        disabledFlag: true,
        show: false,
        couponId: '',
        page: 1,
        total: '',
        loading: false,
        finished: false,
        withAmount: '',
        couponMoney: '',
        goodsList: [],
        use: [],
        keUrl: ''
      }
    },
    mounted () {
      document.title = '优惠券'
      if (location.host == 'xue.eoffcn.com') {
        this.keUrl = '//ke.eoffcn.com'
      } else {
        this.keUrl = '//ke.t.eoffcn.com'
      }
      this.current = 1
      this.getAllCouponList()
    },
    methods: {
      goBack () {
        this.$router.go(-1)
      },
      async getAllCouponList () {
        let useableList = await this.getcoupon(1)
        let unuseableList = await this.getcoupon(2)
        let allData = useableList.concat(unuseableList)
        this.all_coupon_num = allData.length
        this.vip_coupon_num = allData.filter(e => e.source == 2).length
        this.other_coupon_num = allData.filter(e => e.source == 1).length
      },
      checkCode () {
        if (this.couponcode != '') {
          this.disabledFlag = false
        } else {
          this.disabledFlag = true
        }
      },
      validFormat (val) {
        return val.substr(0, 10).replace(/-/g, '.')
      },
      getcoupon (available) {
        return new Promise((resolve, reject) => {
          if (this.appid == 6) {
            this.appid = 2
          } else if (this.appid == 5) {
            this.appid = 3
          }
          this.$api.GETCOUPON({
            'offcn-ticket': this.ticket,
            app_id: this.appid,
            channel_id: this.isAndroid || this.isiOS ? 4 : 2,
            is_available: available
          }).then(res => {
            if (res.code == 0) {
              if (available == 1) {
                var firstTabNum = 0
                if (this.allIndex == 1) {
                  // 全部
                  this.usecouponlist = res.data.list
                  firstTabNum = this.all_coupon_num
                  console.log(firstTabNum)
                } else if (this.allIndex == 2) {
                  // 会员专属
                  this.usecouponlist = res.data.list.filter(e => e.source == 2)
                  firstTabNum = this.vip_coupon_num
                } else {
                  // 其他
                  this.usecouponlist = res.data.list.filter(e => e.source == 1)
                  firstTabNum = this.other_coupon_num
                }
                this.usenum = this.usecouponlist.length
                if (firstTabNum != -1) {
                  this.unusenum = firstTabNum - this.usenum
                }
                resolve(this.usecouponlist)
              } else {
                let firstTabNum = 0
                if (this.allIndex == 1) {
                  // 全部
                  this.couponlist = res.data.list
                  firstTabNum = this.all_coupon_num
                } else if (this.allIndex == 2) {
                  // 会员专属
                  this.couponlist = res.data.list.filter(e => e.source == 2)
                  firstTabNum = this.vip_coupon_num
                } else {
                  // 其他
                  this.couponlist = res.data.list.filter(e => e.source == 1)
                  firstTabNum = this.other_coupon_num
                }
                this.unusenum = this.couponlist.length
                if (firstTabNum != -1) {
                  this.usenum = firstTabNum - this.unusenum
                }
                resolve(this.couponlist)
              }
            } else if (res.code == 2) {
              this.$router.push({path: '/'})
            }
          })
        })
      },
      checkAllTab (index) {
        this.allIndex = index
        this.getcoupon(this.current)
      },
      checkUseableTab (index) {
        this.current = index
        this.getcoupon(index)
      },
      changecoupon () {
        this.$api.CHANGECOUPON({
          'offcn-ticket': this.ticket,
          code: this.couponcode
        }).then(res => {
          if (res.code == 0) {
            this.getcoupon(1)
            setTimeout(() => {
              this.getcoupon(2)
            }, 10)
            this.couponcode = ''
            this.checkCode()
            Toast('兑换成功')
          } else if (res.code == 2) {
            this.$router.push({path: '/'})
          } else {
            Toast(res.msg)
          }
        })
      },
      clearInput () {
        this.couponcode = ''
        this.checkCode()
      },
      closeList () {
        this.show = false
      },
      // 优惠券商品列表
      useCoupon (item) {
        this.couponId = item.coupon.id
        this.withAmount = item.coupon.withAmount
        this.couponMoney = item.coupon.couponMoney
        this.page = 1
        this.goodsList = []
        this.getGoodsList(this.couponId)
      },
      getGoodsList (id) {
        this.$api.GOODSLIST({
          'offcn-ticket': this.ticket,
          couponId: id,
          page: this.page++,
          page_size: 20
        }).then(res => {
          if (res.code == 0) {
            if (res.data.isAllOrExcept == 1) {
              location.href = this.keUrl + '?sf=wxapp'
              return
            }
            if (res.data.list.length == 1) {
              let params = '?phone=' + this.phone + '&sign=' + this.sign + '&platform=' + this.platform + '&version=' + this.version + '?sf=wxapp'
              // location.href = res.data.list[0].url + params

              location.href = this.keUrl + params
            } else {
              this.show = true
              this.loading = false
              this.goodsList = [...this.goodsList, ...res.data.list]
              this.use = res.data.use
              if (this.page == 2) {
                this.total = res.data.total
              }
            }
          } else if (res.code == 2) {
            this.$router.push({path: '/'})
          }
        })
      },
      onLoad () {
        if (this.total === this.goodsList.length) {
          this.finished = true
        } else {
          this.getGoodsList(this.couponId)
        }
      },
      goShop (url) {
        location.href = url + '?phone=' + this.phone + '&sign=' + this.sign + '&platform=' + this.platform + '&version=' + this.version
      }
    }
  }
</script>

<style lang="less" scoped>
  .list-wrapper {
    background: #f5f5f5;
    min-height: 100%;
  }

  .coupon_wrapper {
    height: 100vh;
    background: #ffffff;
    div {
      text-align: center;
      font-size: 26px;
      padding-top: 250px;
      img {
        width: 500px;
        margin-top: 20px;
      }
    }
  }

  .exchange_content {
    padding-bottom: 10px;
    background: #ffffff;
    .exchange_ipt {
      position: relative;
      margin: 0 30px;
      input {
        width: 100%;
        height: 68px;
        font-size: 28px;
        background: #f5f5f5;
        border: none;
        border-radius: 34px;
        margin-top: 20px;
        padding-left: 32px;
      }
      i {
        position: absolute;
        top: 40px;
        right: 170px;
        font-size: 34px;
        color: #cccccc;
      }
      .exchange_btn {
        position: absolute;
        top: 20px;
        right: 0;
        width: 140px;
        height: 68px;
        text-align: center;
        line-height: 68px;
        color: #ffffff;
        font-size: 28px;
        font-weight: bold;
        background: linear-gradient(90deg, #d75b4a 0%, #d33f3a 100%), linear-gradient(#f5f5f5, #f5f5f5);
        border: none;
        border-radius: 34px;
        &.disabled {
          opacity: .7;
        }
      }
    }
    .all_tab {
      margin-top: 20px;
      padding-top: 20px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      text-align: center;
      > span {
        width: 33%;
        font-size: 36px;
        position: relative;
      }
      .all_index {
        color: #333333;
        font-weight: bold;
      }
      .all_index:after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 30%;
        width: 85px;
        height: 4px;
        background: #ed4248;
        color: #e60012;
      }
    }
    .exchange_tab {
      color: #666666;
      font-size: 30px;
      text-align: center;
      margin-top: 50px;
      span:first-child {
        margin-right: 80px;
      }
      span {
        position: relative;
      }
      .content_index {
        color: #333333;
        font-weight: bold;
      }
      .content_index:after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 30%;
        width: 85px;
        height: 4px;
        background: #ed4248;
        color: #e60012;
      }
    }
  }

  .coupon_content {
    padding: 30px 30px;
    .coupon_detail {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 192px;
      border-radius: 20px;
      background: #ffffff;
      padding: 40px 30px;
      margin-bottom: 30px;
      p {
        display: flex;
        flex-direction: column;
      }
      .coupon_left {
        width: 126px;
        text-align: center;
        color: #e60012;
        .coupon_price {
          span {
            font-size: 44px;
            font-weight: bold;
          }
        }
      }
      .coupon_center {
        width: 324px;
        font-size: 28px;
        .coupon_name {
          color: #333333;
          font-weight: bold;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .validity {
          margin-top: 28px;
          font-size: 20px;
          color: #999999;
        }
      }
      .coupon_right {
        width: 120px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        color: #ffffff;
        font-size: 24px;
        border-radius: 30px;
        background: linear-gradient(90deg, #d75b4a 0%, #d33f3a 100%), linear-gradient(#ed4248, #ed4248);
      }
    }
  }

  .coupon_box {
    margin-bottom: 30px;
    .coupon_content_pass {
      justify-content: normal !important;
      border-radius: 20px 20px 0 0;
      margin-bottom: 0 !important;
      .coupon_left {
        color: #999999 !important;
      }
      .coupon_center {
        width: 446px;
        margin-left: 40px;
        .coupon_name {
          color: #999999;
        }
      }
    }
    .pass_tag {
      color: #999999;
      font-size: 24px;
      border-radius: 0 0 20px 20px;
      background: #ebebeb;
      padding: 20px 30px;
    }
  }

  .goods_wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
    .goods_box {
      position: fixed;
      width: 100%;
      bottom: 0;
      height: 854px;
      overflow-y: scroll;
      border-radius: 30px 30px 0px 0px;
      background-color: #ffffff;
    }
  }

  .goods_title {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%);
    color: #333333;
    font-size: 28px;
    font-weight: bold;
    margin-top: 38px;
  }

  .closeList {
    position: absolute;
    top: 38px;
    right: 30px;
    width: 32px;
    height: 32px;
  }

  .goods_rule {
    height: 50px;
    line-height: 50px;
    color: #e60012;
    background: #fce5e7;
    margin-top: 98px;
    padding-left: 30px;
  }

  .goods_list {
    height: calc(100% - 148px);
    margin: 0 30px;
    overflow-y: scroll;
    .goods_content {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e5e5e5;
      padding: 28px 0;
      img {
        width: 186px;
        height: 106px;
        border-radius: 20px;
      }
      .goods_detail {
        margin-left: 22px;
        .goods_name {
          color: #333333;
          font-size: 28px;
          font-weight: bold;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .goods_price {
          font-size: 30px;
          color: #e60012;
          margin-top: 20px;
        }
      }
    }
  }

  .goods_rules {
    padding-left: 30px;
  }

  .unuse_list {
    p {
      color: #999999 !important;
    }
  }

  /deep/ .van-popup__close-icon--top-right {
    top: 38px;
  }
</style>



// WEBPACK FOOTER //
// src/components/coupon/index.vue